<template>
  <div v-if="isLoggedIn" class="mt-1">
    <v-tabs
      v-model="active"
      color="indigo"
      centered
      dark
      slider-color="yellow"
    >
      <v-tab
        v-for="(status, index) in statuses"
        :key="index"
        ripple
         @click="fundingList(index + 1)"
      >
         {{ status }}
      </v-tab>
      <v-tab-item
        v-for="(status, index) in statuses"
        :key="index"
      >
        <v-card flat>
            <Pending v-if="status == 'Pending'"></Pending>
            <Approved v-if="status == 'Approved'"></Approved>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <div class="text-xs-center mt-3">
      <v-btn color="indigo" @click="next">next tab</v-btn>
    </div>
  </div>
  <div centered v-else>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4 md4></v-flex>
        <v-flex xs4 md4 align-end>
          <v-card>
            <v-card-text color="white">
                You are not logged in!
            </v-card-text>
          </v-card>
          <router-link to="/signin">
            <v-btn color="indigo"><v-icon>lock_open</v-icon> login</v-btn>
          </router-link>
        </v-flex>
        <v-flex xs4 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Pending from './Pending'
import Approved from './Approved'

import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        active: null,
        statuses:['Pending', 'Approved']
      }
    },
     components: {
        Pending,
        Approved
    },
    created () {
      this.$store.dispatch('indexData', ['all-fund', 1])
    },
    computed:{
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg', 'investorAgreement', 'investeeAgreement', 'userImage', 'docImage'])
    },

    methods: {
      next () {
        const active = parseInt(this.active)
        var statusId = active + 2
        if(statusId > 2){
          statusId = 1
        }
        this.fundingList(statusId)
        this.active = (active < 1 ? active + 1 : 0)
      },
      fundingList: function(fundingStatusId){
        this.$store.dispatch('indexData', ['all-fund', fundingStatusId])
      }
    }
  }
</script>

<style lang="stylus" scoped>
  
</style>